import { render, staticRenderFns } from "./Wrigley.vue?vue&type=template&id=49c2c156&"
import script from "./Wrigley.vue?vue&type=script&lang=js&"
export * from "./Wrigley.vue?vue&type=script&lang=js&"
import style0 from "./Wrigley.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports